<template>
  <div class="h-100">
    <templateItem v-if="!openDetailShow"></templateItem>
    <templateDetail v-else :selectedTemplate="selectedTemplate" :selectedTemplateId="selectedTemplate.id"></templateDetail>
  </div>
</template>

<script>
import templateItem from './component/quotaTemplateItem'
import templateDetail from './component/quotaTemplateDetail'
let isBack = false
export default {
  name: 'quotationTemplateDefine',
  components: {templateItem, templateDetail},
  data () {
    return {
      openDetailShow: false,
      selectedTemplate: {},
      selectedTemplateId: null
    }
  },
  created () {
    if (isBack) {
      this.openDetailShow = true
      this.selectedTemplate = this.$store.state.quotationTemplate
      this.selectedTemplateId = this.$store.state.quotationTemplateId
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'EnterRoom') {
      isBack = true
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'EnterRoom') {
      isBack = false
      this.$store.dispatch('setQuotationTemplate', {})
    }
    next()
  },
  mounted () {
    // this.selectedTemplateId = this.$store.dispatch('setQuotationTemplateId', this.selectedTemplate.id)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/quotationTemplateDefine.vue